module.exports = __webpack_public_path__ + "static/media/library.22269eb1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/backgrounds/library.jpeg
// module id = 234
// module chunks = 0